import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave", "enter", "enterFrom", "enterTo", "entered", "leave", "leaveFrom", "leaveTo"],
  _excluded2 = ["show", "appear", "unmount"];
import "core-js/modules/es.regexp.flags.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import m, { createContext as Z, Fragment as $, useContext as J, useEffect as F, useMemo as ee, useRef as c, useState as X } from "react";
import { useDisposables as pe } from '../../hooks/use-disposables.js';
import { useEvent as E } from '../../hooks/use-event.js';
import { useFlags as he } from '../../hooks/use-flags.js';
import { useIsMounted as ve } from '../../hooks/use-is-mounted.js';
import { useIsoMorphicEffect as ge } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as A } from '../../hooks/use-latest-value.js';
import { useServerHandoffComplete as te } from '../../hooks/use-server-handoff-complete.js';
import { useSyncRefs as ne } from '../../hooks/use-sync-refs.js';
import { useTransition as Ce } from '../../hooks/use-transition.js';
import { OpenClosedProvider as Ee, State as b, useOpenClosed as re } from '../../internal/open-closed.js';
import { classNames as ie } from '../../utils/class-names.js';
import { match as _ } from '../../utils/match.js';
import { Features as be, forwardRefWithAs as W, render as oe, RenderStrategy as y } from '../../utils/render.js';
function S() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return t.split(/\s+/).filter(function (n) {
    return n.length > 1;
  });
}
var I = Z(null);
I.displayName = "TransitionContext";
var Se = function (r) {
  return r.Visible = "visible", r.Hidden = "hidden", r;
}(Se || {});
function ye() {
  var t = J(I);
  if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
function xe() {
  var t = J(M);
  if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
var M = Z(null);
M.displayName = "NestingContext";
function U(t) {
  return "children" in t ? U(t.children) : t.current.filter(function (_ref) {
    var n = _ref.el;
    return n.current !== null;
  }).filter(function (_ref2) {
    var n = _ref2.state;
    return n === "visible";
  }).length > 0;
}
function se(t, n) {
  var r = A(t),
    s = c([]),
    R = ve(),
    D = pe(),
    p = E(function (i) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : y.Hidden;
      var a = s.current.findIndex(function (_ref3) {
        var o = _ref3.el;
        return o === i;
      });
      a !== -1 && (_(e, _defineProperty(_defineProperty({}, y.Unmount, function () {
        s.current.splice(a, 1);
      }), y.Hidden, function () {
        s.current[a].state = "hidden";
      })), D.microTask(function () {
        var o;
        !U(s) && R.current && ((o = r.current) == null || o.call(r));
      }));
    }),
    x = E(function (i) {
      var e = s.current.find(function (_ref5) {
        var a = _ref5.el;
        return a === i;
      });
      return e ? e.state !== "visible" && (e.state = "visible") : s.current.push({
        el: i,
        state: "visible"
      }), function () {
        return p(i, y.Unmount);
      };
    }),
    h = c([]),
    v = c(Promise.resolve()),
    u = c({
      enter: [],
      leave: [],
      idle: []
    }),
    g = E(function (i, e, a) {
      h.current.splice(0), n && (n.chains.current[e] = n.chains.current[e].filter(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 1),
          o = _ref7[0];
        return o !== i;
      })), n == null || n.chains.current[e].push([i, new Promise(function (o) {
        h.current.push(o);
      })]), n == null || n.chains.current[e].push([i, new Promise(function (o) {
        Promise.all(u.current[e].map(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
            f = _ref9[0],
            N = _ref9[1];
          return N;
        })).then(function () {
          return o();
        });
      })]), e === "enter" ? v.current = v.current.then(function () {
        return n == null ? void 0 : n.wait.current;
      }).then(function () {
        return a(e);
      }) : a(e);
    }),
    d = E(function (i, e, a) {
      Promise.all(u.current[e].splice(0).map(function (_ref0) {
        var _ref1 = _slicedToArray(_ref0, 2),
          o = _ref1[0],
          f = _ref1[1];
        return f;
      })).then(function () {
        var o;
        (o = h.current.shift()) == null || o();
      }).then(function () {
        return a(e);
      });
    });
  return ee(function () {
    return {
      children: s,
      register: x,
      unregister: p,
      onStart: g,
      onStop: d,
      wait: v,
      chains: u
    };
  }, [x, p, s, g, d, u, v]);
}
function Ne() {}
var Pe = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function ae(t) {
  var r;
  var n = {};
  var _iterator = _createForOfIteratorHelper(Pe),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var s = _step.value;
      n[s] = (r = t[s]) != null ? r : Ne;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return n;
}
function Re(t) {
  var n = c(ae(t));
  return F(function () {
    n.current = ae(t);
  }, [t]), n;
}
var De = "div",
  le = be.RenderStrategy;
function He(t, n) {
  var Q, Y;
  var r = t.beforeEnter,
    s = t.afterEnter,
    R = t.beforeLeave,
    D = t.afterLeave,
    p = t.enter,
    x = t.enterFrom,
    h = t.enterTo,
    v = t.entered,
    u = t.leave,
    g = t.leaveFrom,
    d = t.leaveTo,
    i = _objectWithoutProperties(t, _excluded),
    e = c(null),
    a = ne(e, n),
    o = (Q = i.unmount) == null || Q ? y.Unmount : y.Hidden,
    _ye = ye(),
    f = _ye.show,
    N = _ye.appear,
    T = _ye.initial,
    _X = X(f ? "visible" : "hidden"),
    _X2 = _slicedToArray(_X, 2),
    l = _X2[0],
    j = _X2[1],
    z = xe(),
    L = z.register,
    O = z.unregister;
  F(function () {
    return L(e);
  }, [L, e]), F(function () {
    if (o === y.Hidden && e.current) {
      if (f && l !== "visible") {
        j("visible");
        return;
      }
      return _(l, _defineProperty(_defineProperty({}, "hidden", function hidden() {
        return O(e);
      }), "visible", function visible() {
        return L(e);
      }));
    }
  }, [l, e, L, O, f, o]);
  var k = A({
      base: S(i.className),
      enter: S(p),
      enterFrom: S(x),
      enterTo: S(h),
      entered: S(v),
      leave: S(u),
      leaveFrom: S(g),
      leaveTo: S(d)
    }),
    V = Re({
      beforeEnter: r,
      afterEnter: s,
      beforeLeave: R,
      afterLeave: D
    }),
    G = te();
  F(function () {
    if (G && l === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [e, l, G]);
  var Te = T && !N,
    K = N && f && T,
    de = function () {
      return !G || Te ? "idle" : f ? "enter" : "leave";
    }(),
    H = he(0),
    fe = E(function (C) {
      return _(C, {
        enter: function enter() {
          H.addFlag(b.Opening), V.current.beforeEnter();
        },
        leave: function leave() {
          H.addFlag(b.Closing), V.current.beforeLeave();
        },
        idle: function idle() {}
      });
    }),
    me = E(function (C) {
      return _(C, {
        enter: function enter() {
          H.removeFlag(b.Opening), V.current.afterEnter();
        },
        leave: function leave() {
          H.removeFlag(b.Closing), V.current.afterLeave();
        },
        idle: function idle() {}
      });
    }),
    w = se(function () {
      j("hidden"), O(e);
    }, z),
    B = c(!1);
  Ce({
    immediate: K,
    container: e,
    classes: k,
    direction: de,
    onStart: A(function (C) {
      B.current = !0, w.onStart(e, C, fe);
    }),
    onStop: A(function (C) {
      B.current = !1, w.onStop(e, C, me), C === "leave" && !U(w) && (j("hidden"), O(e));
    })
  });
  var P = i,
    ce = {
      ref: a
    };
  return K ? P = _objectSpread(_objectSpread({}, P), {}, {
    className: ie.apply(void 0, [i.className].concat(_toConsumableArray(k.current.enter), _toConsumableArray(k.current.enterFrom)))
  }) : B.current && (P.className = ie(i.className, (Y = e.current) == null ? void 0 : Y.className), P.className === "" && delete P.className), m.createElement(M.Provider, {
    value: w
  }, m.createElement(Ee, {
    value: _(l, _defineProperty(_defineProperty({}, "visible", b.Open), "hidden", b.Closed)) | H.flags
  }, oe({
    ourProps: ce,
    theirProps: P,
    defaultTag: De,
    features: le,
    visible: l === "visible",
    name: "Transition.Child"
  })));
}
function Fe(t, n) {
  var r = t.show,
    _t$appear = t.appear,
    s = _t$appear === void 0 ? !1 : _t$appear,
    _t$unmount = t.unmount,
    R = _t$unmount === void 0 ? !0 : _t$unmount,
    D = _objectWithoutProperties(t, _excluded2),
    p = c(null),
    x = ne(p, n);
  te();
  var h = re();
  if (r === void 0 && h !== null && (r = (h & b.Open) === b.Open), ![!0, !1].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  var _X3 = X(r ? "visible" : "hidden"),
    _X4 = _slicedToArray(_X3, 2),
    v = _X4[0],
    u = _X4[1],
    g = se(function () {
      u("hidden");
    }),
    _X5 = X(!0),
    _X6 = _slicedToArray(_X5, 2),
    d = _X6[0],
    i = _X6[1],
    e = c([r]);
  ge(function () {
    d !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), i(!1));
  }, [e, r]);
  var a = ee(function () {
    return {
      show: r,
      appear: s,
      initial: d
    };
  }, [r, s, d]);
  F(function () {
    if (r) u("visible");else if (!U(g)) u("hidden");else {
      var T = p.current;
      if (!T) return;
      var l = T.getBoundingClientRect();
      l.x === 0 && l.y === 0 && l.width === 0 && l.height === 0 && u("hidden");
    }
  }, [r, g]);
  var o = {
      unmount: R
    },
    f = E(function () {
      var T;
      d && i(!1), (T = t.beforeEnter) == null || T.call(t);
    }),
    N = E(function () {
      var T;
      d && i(!1), (T = t.beforeLeave) == null || T.call(t);
    });
  return m.createElement(M.Provider, {
    value: g
  }, m.createElement(I.Provider, {
    value: a
  }, oe({
    ourProps: _objectSpread(_objectSpread({}, o), {}, {
      as: $,
      children: m.createElement(ue, _objectSpread(_objectSpread(_objectSpread({
        ref: x
      }, o), D), {}, {
        beforeEnter: f,
        beforeLeave: N
      }))
    }),
    theirProps: {},
    defaultTag: $,
    features: le,
    visible: v === "visible",
    name: "Transition"
  })));
}
function _e(t, n) {
  var r = J(I) !== null,
    s = re() !== null;
  return m.createElement(m.Fragment, null, !r && s ? m.createElement(q, _objectSpread({
    ref: n
  }, t)) : m.createElement(ue, _objectSpread({
    ref: n
  }, t)));
}
var q = W(Fe),
  ue = W(He),
  Le = W(_e),
  qe = Object.assign(q, {
    Child: Le,
    Root: q
  });
export { qe as Transition };